import {NgModule} from '@angular/core';
import {
  CommonModule,
  CurrencyPipe,
  DatePipe,
  TitleCasePipe,
} from '@angular/common';
import {DocumentPipe} from './pipes/document.pipe';
import {SubscriptionStatusPipe} from './pipes/subscription-status.pipe';
import {SubscriptionPeriodicityPipe} from './pipes/subscription-periodicity.pipe';
import {SubscriptionBillingTypePipe} from './pipes/subscription-billing-type.pipe';
import {SubscriptionTimingPipe} from './pipes/subscription-timing.pipe';
import {PaymentMethodPipe} from './pipes/payment-method.pipe';
import {ReduceNamePipe} from './pipes/reduce-name.pipe';
import {TransactionTypePipe} from './pipes/transaction-type.pipe';
import {LettersOnlyPipe} from './pipes/letters-only.pipe';
import {PhonePipe} from './pipes/phone.pipe';
import {TransactionTypeIconPipe} from './pipes/transaction-type-icon.pipe';
import {InvoiceStatusPipe} from './pipes/invoice-status.pipe';
import {PermissionPipe} from './pipes/permission.pipe';
import {RecipientTypePipe} from './pipes/recipient-type.pipe';
import {LatestInternalNotePipe} from './pipes/latest-internal-note.pipe';
import {OnboardingStatusPipe} from './pipes/onboarding-status.pipe';
import {CheckoutTypePipe} from './pipes/checkout-type.pipe';
import {CheckoutStatusPipe} from './pipes/checkout-status.pipe';
import {PayoutPolicyPipe} from './pipes/payout-policy.pipe';
import {WithdrawalStatusPipe} from './pipes/withdrawal-status.pipe';
import {UserStatusPipe} from './pipes/user-status.pipe';
import {UserRolePipe} from './pipes/user-role.pipe';
import {ChargebackStatusPipe} from './pipes/chargeback-status.pipe';
import {RiskPipe} from './pipes/risk.pipe';
import {TransactionStatusPipe} from './pipes/transaction-status.pipe';
import {RelativeTimePipe} from './pipes/relative-time.pipe';
import {CamelcasePipe} from './pipes/camel-case.pipe';
import {RecipientStatusPipe} from './pipes/recipient-status.pipe';
import {StandaloneModePipe} from './pipes/standalone-mode.pipe';
import {IntegrationScopePipe} from './pipes/integration-scope.pipe';
import {IntegrationCapabilitiesPipe} from './pipes/integration-capabilities.pipe';
import {IntegrationDescriptionPipe} from './pipes/integration-description.pipe';
import {WalletLabelPipe} from './pipes/wallet-label.pipe';
import {ProviderPipe} from './pipes/provider.pipe';
import {RefundStatusPipe} from './pipes/refund-status.pipe';
import {ProviderHelper} from './helpers/provider.helper';
import {ActionsHelper} from './helpers/actions.helper';
import localePt from '@angular/common/locales/pt';
import {LOCALE_ID} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {PixKeyPipe} from './pipes/pix-key.pipe';
import {SupportTicketMessageAuthorPipe} from './pipes/support-ticket-message-author.pipe';
registerLocaleData(localePt);

const pipes = [
  DocumentPipe,
  SubscriptionStatusPipe,
  SubscriptionPeriodicityPipe,
  SubscriptionBillingTypePipe,
  SubscriptionTimingPipe,
  PaymentMethodPipe,
  ReduceNamePipe,
  TransactionTypePipe,
  LettersOnlyPipe,
  PhonePipe,
  TransactionTypeIconPipe,
  InvoiceStatusPipe,
  PermissionPipe,
  RecipientTypePipe,
  LatestInternalNotePipe,
  OnboardingStatusPipe,
  CheckoutTypePipe,
  CheckoutStatusPipe,
  PaymentMethodPipe,
  DocumentPipe,
  SubscriptionStatusPipe,
  SubscriptionPeriodicityPipe,
  SubscriptionBillingTypePipe,
  SubscriptionTimingPipe,
  PaymentMethodPipe,
  ReduceNamePipe,
  TransactionTypePipe,
  LettersOnlyPipe,
  PhonePipe,
  TransactionTypeIconPipe,
  InvoiceStatusPipe,
  PermissionPipe,
  RecipientTypePipe,
  LatestInternalNotePipe,
  OnboardingStatusPipe,
  CheckoutTypePipe,
  CheckoutStatusPipe,
  PayoutPolicyPipe,
  WithdrawalStatusPipe,
  UserStatusPipe,
  UserRolePipe,
  ChargebackStatusPipe,
  RiskPipe,
  TransactionStatusPipe,
  RelativeTimePipe,
  CamelcasePipe,
  InvoiceStatusPipe,
  RecipientStatusPipe,
  StandaloneModePipe,
  IntegrationScopePipe,
  IntegrationCapabilitiesPipe,
  IntegrationDescriptionPipe,
  ProviderPipe,
  WalletLabelPipe,
  RefundStatusPipe,
  PixKeyPipe,
  SupportTicketMessageAuthorPipe,
];

@NgModule({
  declarations: [...pipes],
  imports: [CommonModule, CurrencyPipe, DatePipe, TitleCasePipe],
  providers: [
    ...pipes,
    CurrencyPipe,
    DatePipe,
    TitleCasePipe,
    ProviderHelper,
    ActionsHelper,
    {provide: LOCALE_ID, useValue: 'pt-BR'},
  ],
  exports: [...pipes],
})
export class UtilsModule {}
